export default __webpack_public_path__ + "static/media/PrevPageIcon.d2d53b1e.svg";